/**
 * Loads Concord.tech cookie banner script
 * @param {string} domainId - Concord domain ID (site ID)
 * @returns {Promise} Resolves when script is loaded
 */
export const loadConcord = (domainId) => {
  return new Promise((resolve, reject) => {
    if (window.Concord) {
      resolve();
      return;
    }

    const existingScript = document.querySelector(`script[data-concord-site-id="${domainId}"]`);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://api.concord.tech/site-v1/${domainId}/site-client`;
    script.type = 'text/javascript';
    script.setAttribute('data-concord-site-id', domainId);

    script.onload = () => {
      resolve();
    };

    script.onerror = (e) => {
      reject(e);
    };

    document.head.appendChild(script);
  });
};
